import React, { useState, useEffect } from 'react';

interface Dish {
  name: string;
  description: string;
  image: string;
}

const dishes: Dish[] = [
  {
    name: 'Orden de cochinita',
    description: 'Deliciosa cochinita pibil preparada al estilo tradicional, acompañada de cebolla morada y tortillas.',
    image: '/img/Menuelchel/tacosdecochinita.jpg',
  },
  {
    name: 'Paella',
    description: 'Paella con una combinación de mariscos, pollo y verduras, preparada con especias auténticas.',
    image: '/img/Menuelchel/paella.JPG',
  },
  {
    name: 'Tacos de relleno negro',
    description: 'Tacos con relleno negro, guiso tradicional del sureste mexicano, servido con tortillas frescas.',
    image: '/img/rollonegro.jpg',
  },
];

const MenuSection: React.FC = () => {
  const [flipped, setFlipped] = useState<number | null>(null);

  // Scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.15 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const toggleFlip = (index: number) => {
    setFlipped(flipped === index ? null : index);
  };

  return (
    <section className="py-12 px-4 bg-[#05603c]">
      {/* Encabezado */}
      <div className="text-center mb-8 reveal">
        <p className="text-brand-deep text-base font-semibold uppercase tracking-widest mb-1">Nuestro menú</p>
        <h3 className="text-[clamp(1.9rem,3.4vw,3rem)] font-extrabold text-white">
          Platillos Destacados
        </h3>
        <div className="w-16 h-1 bg-brand-deep mx-auto mt-3 rounded-full" />
      </div>

      {/* Cards */}
      <div className="flex justify-center gap-6 flex-wrap max-w-[1100px] mx-auto">
        {dishes.map((dish, index) => (
          <div
            key={index}
            onClick={() => toggleFlip(index)}
            className="reveal relative w-[320px] h-[320px] max-md:w-full max-md:max-w-[400px] rounded-2xl overflow-hidden shadow-brand-card cursor-pointer hover:scale-105 hover:-translate-y-1 transition-transform duration-300"
            style={{ transitionDelay: `${index * 0.15}s` }}
          >
            {/* Imagen — siempre presente */}
            <img
              src={dish.image}
              alt={dish.name}
              loading="lazy"
              className="w-full h-full object-cover"
            />
            {/* Overlay — visible en hover (desktop) o click (móvil) */}
            <div
              className={`absolute inset-0 p-6 bg-gradient-to-b from-[#05603c]/95 to-[#033f28]/95 flex flex-col justify-center transition-opacity duration-400 ${
                flipped === index ? 'opacity-100' : 'opacity-0 hover:opacity-100'
              }`}
            >
              <h4 className="text-xl text-white font-extrabold mb-3">{dish.name}</h4>
              <p className="text-sm text-[#ff6d00] leading-relaxed">{dish.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MenuSection;
